import { Component, Input, OnInit } from '@angular/core';
import { BrandService } from '../../../../../../../services/brand.service';
import { LenderListing } from '../../../../../../../shared/lender-listing.model';

@Component({
    selector: 'app-lender-listing',
    templateUrl: './lender-listing.component.html',
    styleUrls: ['./lender-listing.component.scss'],
    standalone: false
})
export class LenderListingComponent implements OnInit {
  @Input() listing!: LenderListing;
  @Input() officeStatus: any;
  @Input() rowNumber!: number;

  public wasabiLogo: string = 'https://s3.us-central-1.wasabisys.com/fru-client-logos/production/';
  public s3Logo: string = 'https://s3-us-west-2.amazonaws.com/fru-client-logos/production/';
  public isTopTenBestLenders: boolean = false;

  constructor(public brandService: BrandService) {
    this.isTopTenBestLenders = this.brandService.isTop10;
  }

  ngOnInit(): void {}

  public time(): number {
    const timestamp = Math.floor(new Date().getTime() / 1000);
    return timestamp;
  }

  public getWasabiLogo(event: any): void {
    console.debug(event);
    event.target.src = this.wasabiLogo + '300x100/' + this.listing.client_id.toLowerCase() + '.png' + this.time();
  }

  public floor(value: number): number {
    return Math.floor(value);
  }

  public ceil(value : number) {
    return Math.ceil(value);
  }
}
